/* ═══════════════════════════════════════════════════════
   BLUSHOVA JS v4 — Complete Theme Logic
   buyblushova.com
═══════════════════════════════════════════════════════ */
'use strict';

/* ─── HEADER SCROLL ─── */
const hdr = document.getElementById('SiteHeader');
if (hdr) {
  window.addEventListener('scroll', () => {
    hdr.classList.toggle('scrolled', window.scrollY > 20);
  }, { passive: true });
}

/* ─── MOBILE MENU ─── */
const hamBtn = document.getElementById('HamburgerBtn');
const mobMenu = document.getElementById('MobileMenu');
const mobClose = document.getElementById('MobMenuClose');
function openMob() {
  mobMenu.classList.add('open');
  hamBtn.classList.add('open');
  hamBtn.setAttribute('aria-expanded', 'true');
  mobMenu.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeMob() {
  mobMenu.classList.remove('open');
  hamBtn.classList.remove('open');
  hamBtn.setAttribute('aria-expanded', 'false');
  mobMenu.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
if (hamBtn) hamBtn.addEventListener('click', () => mobMenu.classList.contains('open') ? closeMob() : openMob());
if (mobClose) mobClose.addEventListener('click', closeMob);
document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeMob(); closeSg(); closeCart(); } });

/* ─── CART ─── */
const cartToggle = document.getElementById('CartToggle');
const cartOverlay = document.getElementById('CartOverlay');
const cartDrawer = document.getElementById('CartDrawer');
const cartClose = document.getElementById('CartClose');
const cartBadge = document.getElementById('CartBadge');

function openCart() {
  cartDrawer && cartDrawer.classList.add('open');
  cartOverlay && cartOverlay.classList.add('open');
  cartDrawer && cartDrawer.setAttribute('aria-hidden', 'false');
  cartToggle && cartToggle.setAttribute('aria-expanded', 'true');
  document.body.style.overflow = 'hidden';
  refreshCart();
}
function closeCart() {
  cartDrawer && cartDrawer.classList.remove('open');
  cartOverlay && cartOverlay.classList.remove('open');
  cartDrawer && cartDrawer.setAttribute('aria-hidden', 'true');
  cartToggle && cartToggle.setAttribute('aria-expanded', 'false');
  document.body.style.overflow = '';
}
if (cartToggle) cartToggle.addEventListener('click', openCart);
if (cartClose) cartClose.addEventListener('click', closeCart);
if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

function fmt(cents) {
  return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-PK');
}

async function refreshCart() {
  try {
    const r = await fetch('/cart.js');
    const cart = await r.json();
    renderCart(cart);
  } catch (e) { console.error('Cart error:', e); }
}

function renderCart(cart) {
  const count = cart.item_count;
  // Badge
  if (cartBadge) {
    cartBadge.textContent = count;
    cartBadge.classList.toggle('show', count > 0);
  }
  // Free delivery bar
  const thresh = window.BL?.freeShip || 300000;
  const fill = document.getElementById('FreeDelFill');
  const msg = document.getElementById('FreeDelMsg');
  if (fill) fill.style.width = Math.min((cart.total_price / thresh) * 100, 100) + '%';
  if (msg) {
    if (cart.total_price >= thresh) {
      msg.innerHTML = '🎉 <strong>You\'ve unlocked FREE delivery!</strong>';
      msg.style.color = '#2d6a2d';
    } else {
      const rem = fmt(thresh - cart.total_price);
      msg.innerHTML = `Add <strong>${rem}</strong> more for <strong>FREE delivery!</strong>`;
      msg.style.color = '';
    }
  }
  // Subtotal
  const sub = document.getElementById('CartSubtotal');
  if (sub) sub.textContent = fmt(cart.total_price);
  // Footer
  const ft = document.getElementById('CartFooter');
  const upsell = document.getElementById('CartUpsell');
  if (ft) ft.style.display = count > 0 ? 'block' : 'none';
  if (upsell) upsell.style.display = count > 0 ? 'block' : 'none';
  // Items
  const itemsEl = document.getElementById('CartItems');
  const emptyEl = document.getElementById('CartEmpty');
  if (!itemsEl) return;
  if (count === 0) {
    if (emptyEl) emptyEl.style.display = 'flex';
    const list = document.getElementById('CartItemsList');
    if (list) list.remove();
    return;
  }
  if (emptyEl) emptyEl.style.display = 'none';
  let list = document.getElementById('CartItemsList');
  if (!list) { list = document.createElement('div'); list.id = 'CartItemsList'; itemsEl.appendChild(list); }
  list.innerHTML = cart.items.map(item => `
    <div class="cart-item">
      <img class="cart-item__img" src="${item.image || ''}" alt="${escHtml(item.title)}" loading="lazy">
      <div class="cart-item__info">
        <a href="${item.url}" class="cart-item__title">${escHtml(item.product_title)}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${escHtml(item.variant_title)}</p>` : ''}
        <p class="cart-item__price">${fmt(item.price)}</p>
        <div class="cart-item__qty">
          <a href="/cart/change?id=${item.key}&quantity=${Math.max(0, item.quantity - 1)}" class="qty-link" aria-label="Decrease">−</a>
          <span>${item.quantity}</span>
          <a href="/cart/change?id=${item.key}&quantity=${item.quantity + 1}" class="qty-link" aria-label="Increase">+</a>
        </div>
        <a href="/cart/change?id=${item.key}&quantity=0" class="cart-item__remove" role="button">Remove</a>
      </div>
      <span class="cart-item__price" style="align-self:center">${fmt(item.line_price)}</span>
    </div>
  `).join('');
}

function escHtml(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

async function addToCart(variantId, qty = 1) {
  try {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!r.ok) throw new Error('Add to cart failed');
    await refreshCart();
    return true;
  } catch (e) { console.error(e); return false; }
}

// Quick add from product cards
document.addEventListener('click', async e => {
  const btn = e.target.closest('.prod-card__quick-add');
  if (!btn) return;
  e.preventDefault();
  const vid = btn.dataset.variant;
  if (!vid) return;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  const ok = await addToCart(vid);
  if (ok) {
    btn.textContent = '✓ Added!';
    openCart();
    setTimeout(() => { btn.textContent = '+ Quick Add'; btn.disabled = false; }, 2000);
  } else {
    btn.textContent = 'Error';
    btn.disabled = false;
  }
});

// Cart upsell quick add
document.addEventListener('click', async e => {
  const btn = e.target.closest('.cart-upsell__add, .upsell-atc');
  if (!btn) return;
  e.preventDefault();
  const vid = btn.dataset.variant;
  if (!vid) return;
  btn.textContent = '...';
  btn.disabled = true;
  await addToCart(vid);
  btn.textContent = '✓';
  setTimeout(() => { btn.textContent = '+'; btn.disabled = false; }, 1500);
});

// Init cart on load
refreshCart();

/* ─── ACCORDION ─── */
document.addEventListener('click', e => {
  const trigger = e.target.closest('.acc-trigger');
  if (!trigger) return;
  const item = trigger.closest('.acc-item');
  const body = item.querySelector('.acc-body');
  const isOpen = item.classList.contains('open');
  // Close all in same accordion
  const acc = item.closest('.accordion');
  if (acc) {
    acc.querySelectorAll('.acc-item.open').forEach(oi => {
      oi.classList.remove('open');
      oi.querySelector('.acc-trigger').setAttribute('aria-expanded', 'false');
      const b = oi.querySelector('.acc-body');
      if (b) b.style.maxHeight = null;
    });
  }
  if (!isOpen) {
    item.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
    if (body) body.style.maxHeight = body.scrollHeight + 'px';
  }
});

/* ─── SIZE GUIDE MODAL ─── */
const sgOverlay = document.getElementById('SgOverlay');
const sgClose = document.getElementById('SgClose');
function openSg() {
  if (!sgOverlay) return;
  sgOverlay.classList.add('open');
  sgOverlay.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeSg() {
  if (!sgOverlay) return;
  sgOverlay.classList.remove('open');
  sgOverlay.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
document.addEventListener('click', e => {
  if (e.target.closest('.open-size-guide, .sg-open-btn')) openSg();
});
if (sgClose) sgClose.addEventListener('click', closeSg);
if (sgOverlay) sgOverlay.addEventListener('click', e => { if (e.target === sgOverlay) closeSg(); });

/* ─── PRODUCT PAGE ─── */
const productDataEl = document.getElementById('ProductData');
if (productDataEl) {
  const product = JSON.parse(productDataEl.textContent);
  let selOpts = {};
  let curVariant = product.variants.find(v => v.available) || product.variants[0];

  // Gallery thumbs
  const mainImg = document.getElementById('GalleryMainImg');
  document.querySelectorAll('.gallery-thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb').forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
      if (mainImg) { mainImg.src = btn.dataset.src; mainImg.alt = btn.dataset.alt || product.title; }
    });
  });

  // Touch swipe gallery
  const galleryMain = document.getElementById('GalleryMain');
  if (galleryMain) {
    let sx = 0;
    galleryMain.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) < 50) return;
      const imgs = product.images;
      if (!imgs || imgs.length < 2) return;
      const cur = Array.from(document.querySelectorAll('.gallery-thumb')).findIndex(b => b.classList.contains('active'));
      const next = (cur + (dx < 0 ? 1 : -1) + imgs.length) % imgs.length;
      document.querySelectorAll('.gallery-thumb')[next]?.click();
    }, { passive: true });
  }

  // Option buttons
  function findVariant() {
    return product.variants.find(v => Object.entries(selOpts).every(([pos, val]) => v.options[parseInt(pos) - 1] === val));
  }

  function updateVariant(v) {
    if (!v) return;
    curVariant = v;
    const priceEl = document.getElementById('ProdPrice');
    const compareEl = document.getElementById('ProdCompare');
    const saveEl = document.getElementById('ProdSaveBadge');
    if (priceEl) priceEl.textContent = fmt(v.price);
    if (compareEl) {
      if (v.compare_at_price > v.price) {
        compareEl.textContent = fmt(v.compare_at_price);
        compareEl.style.display = 'inline';
        if (saveEl) { saveEl.textContent = 'Save ' + fmt(v.compare_at_price - v.price); saveEl.style.display = 'inline'; }
      } else {
        compareEl.style.display = 'none';
        if (saveEl) saveEl.style.display = 'none';
      }
    }
    const atcBtn = document.getElementById('MainAtcBtn');
    if (atcBtn) {
      atcBtn.disabled = !v.available;
      atcBtn.textContent = v.available ? '🛒 Add to Cart' : 'Sold Out';
    }
    const sel = document.getElementById('VariantSelect');
    if (sel) sel.value = v.id;
    if (v.featured_image && mainImg) mainImg.src = v.featured_image.src;
    // Sticky price
    const sp = document.getElementById('StickyPrice');
    if (sp) sp.textContent = fmt(v.price);
    updateWaLink();
    updateStickyMeta();
  }

  document.querySelectorAll('.sz-btn, .color-swatch').forEach(btn => {
    btn.addEventListener('click', () => {
      const pos = btn.dataset.opt;
      const val = btn.dataset.val;
      selOpts[pos] = val;
      document.querySelectorAll(`[data-opt="${pos}"]`).forEach(b => { b.classList.remove('active'); b.setAttribute('aria-pressed', 'false'); });
      btn.classList.add('active');
      btn.setAttribute('aria-pressed', 'true');
      const lbl = document.getElementById(`Opt${pos}Val`);
      if (lbl) lbl.textContent = val;
      const v = findVariant();
      if (v) updateVariant(v);
    });
  });

  // Init selOpts from active buttons
  document.querySelectorAll('.sz-btn.active, .color-swatch.active').forEach(btn => {
    selOpts[btn.dataset.opt] = btn.dataset.val;
  });

  // Quantity
  const qtyInput = document.getElementById('QtyInput');
  document.getElementById('QtyPlus')?.addEventListener('click', () => { if (qtyInput) qtyInput.value = parseInt(qtyInput.value || 1) + 1; });
  document.getElementById('QtyMinus')?.addEventListener('click', () => { if (qtyInput && parseInt(qtyInput.value) > 1) qtyInput.value = parseInt(qtyInput.value) - 1; });

  // Add to cart
  const mainAtcBtn = document.getElementById('MainAtcBtn');
  if (mainAtcBtn) {
    mainAtcBtn.addEventListener('click', async () => {
      const vid = document.getElementById('VariantSelect')?.value || curVariant.id;
      const qty = parseInt(document.getElementById('QtyInput')?.value || 1);
      mainAtcBtn.textContent = 'Adding...';
      mainAtcBtn.disabled = true;
      const ok = await addToCart(vid, qty);
      if (ok) {
        mainAtcBtn.textContent = '✓ Added!';
        showUpsell();
        openCart();
        setTimeout(() => { mainAtcBtn.textContent = '🛒 Add to Cart'; mainAtcBtn.disabled = false; }, 2000);
      } else {
        mainAtcBtn.textContent = 'Error — try again';
        mainAtcBtn.disabled = false;
      }
    });
  }

  // Sticky ATC
  document.getElementById('StickyAtcBtn')?.addEventListener('click', () => mainAtcBtn?.click());

  // WhatsApp link builder
  function updateWaLink() {
    const size = selOpts['1'] || '';
    const color = selOpts['2'] || '';
    const price = fmt(curVariant.price);
    const msg = encodeURIComponent(
      `Hi BLUSHOVA! I want to order:\n*${product.title}*\nSize: ${size}\nColor: ${color}\nPrice: ${price}\nLink: ${location.href}\n\nPlease confirm my order.`
    );
    const wa = `https://wa.me/${window.BL.wa}?text=${msg}`;
    const btn = document.getElementById('WaBtn');
    const sBtn = document.getElementById('StickyWaBtn');
    if (btn) btn.href = wa;
    if (sBtn) sBtn.href = wa;
  }

  function updateStickyMeta() {
    const el = document.getElementById('StickyMeta');
    const parts = [selOpts['1'], selOpts['2']].filter(Boolean);
    if (el) el.textContent = parts.length ? parts.join(' · ') : 'Select size';
  }

  updateWaLink();
  updateStickyMeta();

  // Sticky ATC observer
  const stickyBar = document.getElementById('StickyAtc');
  if (stickyBar && mainAtcBtn) {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => stickyBar.classList.toggle('show', !e.isIntersecting));
    }, { threshold: 0, rootMargin: '0px 0px -10px 0px' });
    obs.observe(mainAtcBtn);
    const footer = document.querySelector('.site-footer');
    if (footer) {
      const fobs = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) stickyBar.classList.remove('show');
      }, { threshold: 0 });
      fobs.observe(footer);
    }
  }

  // FBT
  const fbtAtcBtn = document.getElementById('FbtAtcBtn');
  const fbtTotal = document.getElementById('FbtTotal');
  function calcFbtTotal() {
    let total = curVariant.price;
    document.querySelectorAll('.fbt-cb:checked').forEach(cb => { total += parseInt(cb.dataset.price || 0); });
    if (fbtTotal) fbtTotal.textContent = fmt(total);
  }
  document.querySelectorAll('.fbt-cb').forEach(cb => cb.addEventListener('change', calcFbtTotal));
  if (fbtAtcBtn) {
    fbtAtcBtn.addEventListener('click', async () => {
      const vid = document.getElementById('VariantSelect')?.value || curVariant.id;
      const qty = parseInt(document.getElementById('QtyInput')?.value || 1);
      const adds = Array.from(document.querySelectorAll('.fbt-cb:checked')).map(cb => cb.dataset.variant);
      fbtAtcBtn.textContent = 'Adding...';
      fbtAtcBtn.disabled = true;
      await addToCart(vid, qty);
      for (const av of adds) { await addToCart(av, 1); }
      fbtAtcBtn.textContent = '✓ Added All!';
      openCart();
      setTimeout(() => { fbtAtcBtn.textContent = 'Add Selected to Cart'; fbtAtcBtn.disabled = false; }, 2000);
    });
  }

  // Urgency view count
  const vc = document.getElementById('ViewCount');
  if (vc) {
    let base = parseInt(vc.textContent) || 12;
    setInterval(() => {
      base = Math.max(5, base + (Math.random() > 0.5 ? 1 : -1));
      vc.textContent = `${Math.round(base)} people`;
    }, 8000);
  }
}

/* ─── UPSELL POPUP ─── */
const upsellPopup = document.getElementById('UpsellPopup');
const upsellClose = document.getElementById('UpsellClose');
const upsellCont = document.getElementById('UpsellContinue');
function showUpsell() {
  if (!upsellPopup) return;
  upsellPopup.classList.add('show');
  upsellPopup.setAttribute('aria-hidden', 'false');
}
function hideUpsell() {
  if (!upsellPopup) return;
  upsellPopup.classList.remove('show');
  upsellPopup.setAttribute('aria-hidden', 'true');
}
if (upsellClose) upsellClose.addEventListener('click', hideUpsell);
if (upsellCont) upsellCont.addEventListener('click', hideUpsell);
if (upsellPopup) upsellPopup.addEventListener('click', e => { if (e.target === upsellPopup) hideUpsell(); });

/* ─── REVIEWS ─── */
const showMoreBtn = document.getElementById('ShowMoreReviews');
if (showMoreBtn) {
  showMoreBtn.addEventListener('click', () => {
    const hidden = document.querySelectorAll('.review-card--hidden');
    hidden.forEach(el => { el.classList.remove('review-card--hidden'); el.classList.add('visible'); });
    showMoreBtn.style.display = 'none';
  });
}

// Star picker
const rfStars = document.querySelectorAll('.rf-star');
const ratingInput = document.getElementById('RatingVal');
rfStars.forEach((star, i) => {
  star.addEventListener('click', () => {
    const val = parseInt(star.dataset.val);
    if (ratingInput) ratingInput.value = val;
    rfStars.forEach((s, j) => s.classList.toggle('active', j < val));
  });
  star.addEventListener('mouseenter', () => {
    const val = parseInt(star.dataset.val);
    rfStars.forEach((s, j) => s.style.color = j < val ? 'var(--s)' : 'var(--mkl)');
  });
});
const rfPicker = document.querySelector('.rf-stars');
if (rfPicker) rfPicker.addEventListener('mouseleave', () => {
  const val = parseInt(ratingInput?.value || 0);
  rfStars.forEach((s, j) => s.style.color = j < val ? 'var(--s)' : 'var(--mkl)');
});

// Review form submit
const reviewForm = document.getElementById('ReviewForm');
if (reviewForm) {
  reviewForm.addEventListener('submit', e => {
    e.preventDefault();
    const rating = document.getElementById('RatingVal')?.value;
    const author = document.getElementById('RfName')?.value.trim();
    const email = document.getElementById('RfEmail')?.value.trim();
    const body = document.getElementById('RfBody')?.value.trim();
    if (!rating || !author || !email || !body) { alert('Please fill in all fields and select a rating.'); return; }
    const success = document.getElementById('RfSuccess');
    if (success) success.style.display = 'block';
    reviewForm.reset();
    rfStars.forEach(s => { s.classList.remove('active'); s.style.color = 'var(--mkl)'; });
  });
}

/* ─── SORT ON COLLECTION PAGE ─── */
const sortSel = document.getElementById('SortBy');
if (sortSel) {
  sortSel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSel.value);
    window.location.href = url.toString();
  });
}

/* ─── NEWSLETTER ─── */
const nlForm = document.querySelector('.nl-form');
if (nlForm) {
  nlForm.addEventListener('submit', () => {
    // Shopify handles this via form action
  });
}
